var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"splash"}},[_c('Header',[_c('div',{staticClass:"big-text"},[_vm._v("xoxo doesn't work on Safari.")]),_c('div',{staticClass:"small-text"},[_vm._v("Apple doesn't like WebRTC, use Chrome or Firefox :(")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }